export default __webpack_public_path__ + "static/image7-af1bf6d26f61f86c446f3db857a7dfbd.jpeg";